var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailAccountIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.0001C17.5 8.43303 17.0092 6.90528 16.0964 5.63146C15.1836 4.35764 13.8947 3.40174 12.4108 2.89801C10.9268 2.39429 9.32237 2.36805 7.82275 2.82298C6.32314 3.27791 5.00369 4.19116 4.04973 5.43445C3.09577 6.67774 2.55522 8.18863 2.50401 9.75489C2.45279 11.3212 2.89348 12.8641 3.76419 14.1671C4.63489 15.47 5.89186 16.4675 7.35855 17.0195C8.82525 17.5714 10.428 17.65 11.9417 17.2443",
    stroke: "#4C6484",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 13.3307C11.8403 13.3307 13.3327 11.8383 13.3327 9.9974C13.3327 8.15645 11.8403 6.66406 9.99935 6.66406C8.1584 6.66406 6.66602 8.15645 6.66602 9.9974C6.66602 11.8383 8.1584 13.3307 9.99935 13.3307Z",
    stroke: "#4C6484",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 7.5V11.25C13.334 11.8025 13.5535 12.3324 13.9442 12.7231C14.3349 13.1138 14.8648 13.3333 15.4173 13.3333C15.9699 13.3333 16.4998 13.1138 16.8905 12.7231C17.2812 12.3324 17.5007 11.8025 17.5007 11.25V10",
    stroke: "#4C6484",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailAccountIcon);
export default __webpack_public_path__ + "static/media/email-account-icon.feddecf214cf53e447038b48dab60180.svg";
export { ForwardRef as ReactComponent };